import type { InitOutput } from "../wasm/vault-crypto/vault_crypto_wasm";

let initPromise: Promise<InitOutput> | null = null;
async function ensureReady() {
  if (!initPromise) {
    const mod = await import("../wasm/vault-crypto/vault_crypto_wasm");
    const wasmPath = new URL(
      "../wasm/vault-crypto/vault_crypto_wasm_bg.wasm",
      import.meta.url
    );
    const bytes = await fetch(wasmPath).then((r) => r.arrayBuffer());
    initPromise = Promise.resolve(mod.initSync({ module: bytes }));
  }
  return initPromise;
}

export interface OpaqueRegisterStartResult {
  clientRegistrationState: string;
  registrationRequest: string;
}

export interface OpaqueRegisterFinishResult {
  registrationRecord: string;
  exportKey: string;
}

export interface OpaqueLoginStartResult {
  clientLoginState: string;
  startLoginRequest: string;
}

export interface OpaqueLoginFinishResult {
  sessionKey: string;
  exportKey: string;
  finishLoginRequest: string;
}

export async function startOpaqueRegister(
  password: string
): Promise<OpaqueRegisterStartResult> {
  await ensureReady();
  const { register_start } = await import(
    "../wasm/vault-crypto/vault_crypto_wasm"
  );
  return JSON.parse(register_start(password));
}

export async function finishOpaqueRegister(
  clientRegistrationState: string,
  registrationResponse: string
): Promise<OpaqueRegisterFinishResult> {
  await ensureReady();
  const { register_finish } = await import(
    "../wasm/vault-crypto/vault_crypto_wasm"
  );
  return JSON.parse(
    register_finish(clientRegistrationState, registrationResponse)
  );
}

export async function startOpaqueLogin(
  password: string
): Promise<OpaqueLoginStartResult> {
  await ensureReady();
  const { login_start } = await import(
    "../wasm/vault-crypto/vault_crypto_wasm"
  );
  return JSON.parse(login_start(password));
}

export async function finishOpaqueLogin(
  clientLoginState: string,
  loginResponse: string
): Promise<OpaqueLoginFinishResult> {
  await ensureReady();
  const { login_finish } = await import(
    "../wasm/vault-crypto/vault_crypto_wasm"
  );
  return JSON.parse(login_finish(clientLoginState, loginResponse));
}
